import React from "react";
import "./footer.component.scss";
import { Link } from "react-router-dom";
import _ from "lodash";

import releaseNotes from "../../../../jsons/releaseNotes.json";

export default function Footer() {
    const orderedChangeLogs = _.sortBy(releaseNotes, "version").reverse();

    return (
        <div id="Footer">
            <div className="footer-content">
                <div className="footer-left">
                    {/*<Link to={"/help"}>Help</Link>
                    <Link to={"/release-notes"}>Release Notes</Link>
    <Link to={"/credits"}>Credits</Link>*/}
                        v{orderedChangeLogs[0].version}
                </div>
                <div className="footer-right">Copyright © FABAMAQ</div>
            </div>
        </div>
    );
}
